import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { formatDate } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountServiceProvider } from '../../providers/account-service/account-service';

@Component({
	selector      : 'app-form-modal',
	templateUrl   : './form-modal.component.html',
	encapsulation : ViewEncapsulation.None
})

export class FormModalComponent implements OnInit {
	formGroup : FormGroup;
	minDate = formatDate( new Date(), 'yyyy-mm-dd', 'en' );
	public form_content     : any;
	public form_title       : any;	
	public errorMessageText : any;
	public DateFilled         : boolean = false;
	public HeadlineFilled     : boolean = false;
	public LinkFilled         : boolean = false;
	public OrganisationFilled : boolean = false;
	public sendButton         : boolean = false;
	public errorMessage       : boolean = false;	

	constructor(
		public formBuilder     : FormBuilder,
		public activeModal     : NgbActiveModal, 
		private accountService : AccountServiceProvider,
	) {}

	ngOnInit() {
		var userData = JSON.parse( window.localStorage.getItem( 'userData' ) );
		this.formGroup = this.formBuilder.group({
			Date: [ '', [ Validators.required, Validators.email ] ],
			Headline: [ '', [ Validators.required ] ],
			Link: [ '' , [ Validators.required ] ],
			Organisation: [ userData.organization ],
		});
		this.Date.valueChanges.subscribe(() => {
			if ( this.Date.value != '' )
				this.DateFilled = true;
			else
				this.DateFilled = false;
		});
		this.Headline.valueChanges.subscribe(() => {
			if ( this.Headline.value != '' )
				this.HeadlineFilled = true;
			else
				this.HeadlineFilled = false;
		});
		this.Link.valueChanges.subscribe(() => {
			if ( this.Link.value != '' )
				this.LinkFilled = true;
			else
				this.LinkFilled = false;
		});
	}

	get Date() { return this.formGroup.get('Date'); }
	get Headline() { return this.formGroup.get('Headline'); }
	get Link() { return this.formGroup.get('Link'); }
	get Organisation() { return this.formGroup.get('Organisation'); }

	doSubmitConvenor() {
		this.errorMessage = false;
		this.errorMessageText = '';
		var userData = JSON.parse( window.localStorage.getItem( 'userData' ) );
		var press_id = 0;
		var press_date = this.formGroup.value.Date.month + '/' + this.formGroup.value.Date.day + '/'+ this.formGroup.value.Date.year;
		var press_headline = this.formGroup.value.Headline;
		var press_link = this.formGroup.value.Link;
		var press_org = this.formGroup.value.Organisation;
		let params = {
			'ReleaseDate'    : press_date,
			'Headline'       : press_headline,
			'Link'           : press_link,
			'OrganizationName' : press_org,
		};
		this.sendButton = true;
		this.accountService.addConvenorPress( params ).then( ( dotnetresponse: any ) => {
			if ( 'Ok' == dotnetresponse.status ) {
				this.form_content = '<p class="success-msg">Press release submitted successfully. It will be published once admin have accepted the press release.</p>';
				this.formGroup.reset();
				this.DateFilled = false;
				this.HeadlineFilled = false;
				this.LinkFilled = false;
				this.OrganisationFilled = this.formGroup.value.Organisation;
				document.getElementById( 'convenor__send_press' ).classList.add( 'hide' );
			} else if( 'Error' == dotnetresponse.status ) {
				this.errorMessage = true;
				this.errorMessageText = dotnetresponse.message;
			} else {
				this.form_content = '<p class="error-msg">Some Error Occured. Please try again later.</p>';
			}
			this.sendButton = false;
		});
	}
}